import React, { useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  makeStyles,
  FormHelperText,
  FormControl,
  MenuItem,
  Select,
  Radio,
  RadioGroup,
  FormControlLabel,
  CircularProgress,
  IconButton,
} from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import ApiConfig from "../../config/ApiConfig";
import Axios from "axios";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Delete } from "@material-ui/icons";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: theme.spacing(3),
  },
  formContainer: {
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
    padding: theme.spacing(4),
    border: "1px solid #e0e0e0",
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: "600",
    color: "#2c3e50",
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    borderBottom: "2px solid #00d4ff",
  },
  TextBox: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00d4ff",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00d4ff",
        borderWidth: "2px",
      },
    },
  },
  label: {
    fontWeight: "600",
    fontSize: "0.95rem",
    color: "#34495e",
    marginBottom: theme.spacing(1),
    display: "block",
  },
  select: {
    "& .MuiOutlinedInput-root": {
      height: "48px",
      borderRadius: "8px",
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00d4ff",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00d4ff",
        borderWidth: "2px",
      },
    },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      padding: "12px 14px",
    },
  },
  date: {
    color: "#e74c3c",
    fontSize: "0.875rem",
    marginTop: theme.spacing(0.5),
  },
  btn: {
    minWidth: "120px",
    height: "44px",
    background: "linear-gradient(135deg, #00d4ff 0%, #0099cc 100%)",
    color: "white",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: "600",
    fontSize: "0.95rem",
    boxShadow: "0 2px 8px rgba(0, 212, 255, 0.3)",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "linear-gradient(135deg, #0099cc 0%, #007aa3 100%)",
      boxShadow: "0 4px 12px rgba(0, 212, 255, 0.4)",
      transform: "translateY(-1px)",
    },
  },
  btn1: {
    background: "linear-gradient(135deg, #00d4ff 0%, #0099cc 100%)",
    color: "white",
    minWidth: "180px",
    height: "44px",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: "600",
    fontSize: "0.95rem",
    boxShadow: "0 2px 8px rgba(0, 212, 255, 0.3)",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "linear-gradient(135deg, #0099cc 0%, #007aa3 100%)",
      boxShadow: "0 4px 12px rgba(0, 212, 255, 0.4)",
      transform: "translateY(-1px)",
    },
  },
  uploadSection: {
    background: "#f8f9fa",
    borderRadius: "12px",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    border: "2px dashed #dee2e6",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "#00d4ff",
      background: "#f0fdff",
    },
  },
  uploadTitle: {
    fontSize: "1.25rem",
    fontWeight: "600",
    color: "#2c3e50",
    marginBottom: theme.spacing(2),
    textAlign: "center",
  },
  uploadGrid: {
    marginTop: theme.spacing(2),
  },
  videoContainer: {
    position: "relative",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  imageContainer: {
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  colorbox1: {
    width: "100%",
    "& .MuiGrid-container": {
      display: "block !important",
    },
    "& .MuiGrid-grid-xs-4": {
      maxWidth: "100%",
    },
    "& .MuiDropzoneArea-textContainer": {
      display: "none",
    },
    "& .MuiDropzonePreviewList-image": {
      height: "100%",
      maxHeight: "200px",
      borderRadius: "8px",
    },
    "& .MuiDropzonePreviewList-removeButton": {
      display: "block",
      top: "8px",
      right: "8px",
      width: "32px",
      height: "32px",
      opacity: 0.8,
      position: "absolute",
      transition: "opacity 0.3s ease",
      background: "rgba(255, 255, 255, 0.9)",
      borderRadius: "50%",
      "&:hover": {
        opacity: 1,
        background: "rgba(255, 255, 255, 1)",
      },
    },
    "& .MuiDropzoneArea-root": {
      border: "2px dashed #dee2e6",
      borderRadius: "8px",
      background: "#f8f9fa",
      transition: "all 0.3s ease",
      "&:hover": {
        borderColor: "#00d4ff",
        background: "#f0fdff",
      },
    },
  },
  colorbox: {
    width: "100%",
    "& .MuiGrid-container": {
      display: "block !important",
    },
    "& .MuiGrid-grid-xs-4": {
      maxWidth: "100%",
    },
    "& .MuiDropzoneArea-textContainer": {
      display: "block !important",
    },
    "& .MuiDropzonePreviewList-removeButton": {
      display: "block",
      top: "8px",
      right: "8px",
      width: "32px",
      height: "32px",
      opacity: 0.8,
      position: "absolute",
      transition: "opacity 0.3s ease",
      background: "rgba(255, 255, 255, 0.9)",
      borderRadius: "50%",
      "&:hover": {
        opacity: 1,
        background: "rgba(255, 255, 255, 1)",
      },
    },
    "& .MuiDropzoneArea-root": {
      border: "2px dashed #dee2e6",
      borderRadius: "8px",
      background: "#f8f9fa",
      transition: "all 0.3s ease",
      "&:hover": {
        borderColor: "#00d4ff",
        background: "#f0fdff",
      },
    },
  },
  deleteBTN: {
    position: "absolute",
    top: "8px",
    right: "8px",
    zIndex: 100,
    background: "rgba(255, 255, 255, 0.9)",
    opacity: 0.8,
    transition: "all 0.3s ease",
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    "&:hover": {
      opacity: 1,
      background: "rgba(255, 255, 255, 1)",
      transform: "scale(1.1)",
    },
  },
  formSection: {
    marginBottom: theme.spacing(4),
  },
  resultSection: {
    background: "#f8f9fa",
    borderRadius: "12px",
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  radioGroup: {
    marginTop: theme.spacing(2),
  },
  radioLabel: {
    fontSize: "1rem",
    fontWeight: "500",
    color: "#2c3e50",
  },
  resultValueDisplay: {
    fontWeight: "600",
    padding: "12px 16px",
    border: "2px solid #e0e0e0",
    borderRadius: "8px",
    background: "#ffffff",
    color: "#2c3e50",
    textAlign: "center",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(3),
    borderTop: "1px solid #e0e0e0",
  },
  uploadButtonContainer: {
    textAlign: "center",
    marginTop: theme.spacing(2),
  },
  uploadedStatus: {
    color: "#27ae60",
    fontWeight: "600",
    fontSize: "1rem",
  },
}));

function Addtest() {
  const history = useHistory();
  const classes = useStyles();
  const [value, setValue] = useState("QUALITATIVE");
  const [loader, setLoader] = useState(false);
  const [videoBase64, setVideoBase64] = useState(null);
  const [link, setLink] = useState(null);
  const [image, setImage] = useState("");
    const [testIMG, setTestIMG] = useState(null);
  const [image1, setImage1] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [incubationType, setIncubationType] = useState("SEC");
  const [expirationType, setExpirationType] = useState("SEC");

  const handleVideoChange = (files) => {
    const file = files[0];
    if (file) {
      getVideoDuration(file)
        .then((duration) => {
          if (duration <= 90) {
            return getBase64Data(file);
          } else {
            toast.error("Video duration exceeds 90 seconds.");
            throw new Error("Video duration exceeds 90 seconds.");
          }
        })
        .then((base64) => {
          setVideoBase64(base64);
        })
        .catch((error) => {
          console.error("Error handling video:", error);
        });
    }
  };

  const getVideoDuration = (file) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = function () {
        resolve(video.duration);
      };
      video.onerror = (error) => {
        reject(error);
      };
      video.src = URL.createObjectURL(file);
    });
  };

  const getBase64Data = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const handleDrop = (files) => {
    if (files.length > 0) {
      setImage1(files[0]);
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result);
        setTestIMG(e.target.result);
      };
      reader.readAsDataURL(files[0]);
    }
  };
 
  const uploadIMG = async () => {
    if (!testIMG) { // Now checking the correct state variable
      toast.error("No image selected");
      return;
    }
  
    setLoader(true);
    try {
      const base64Data = testIMG.includes(',') ? 
        testIMG.split(',')[1] : 
        testIMG.replace(/^data:image\/\w+;base64,/, '');
      
      const res = await Axios({
        method: "POST",
        url: ApiConfig.uploadImage,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
          'Content-Type': 'application/json'
        },
        data: [base64Data]
      });
  
      if (res.data.status === 200) {
        setProfileImage(res.data.data[0]);
        toast.success("Image uploaded successfully");
      } else {
        toast.error(res.data.message || "Image upload failed");
      }
    } catch (error) {
      console.error("Image upload error:", error);
      toast.error(error.response?.data?.message || "Failed to upload image");
    } finally {
      setLoader(false);
    }
  };

  const [formData, setFormData] = useState({
    testName: "",
    unit: "",
    incubation: "",
    expirationTime: "",
    positiveValue: "",
    positiveColorCode: "",
    negativeValue: "",
    negativeColorCode: "",
    acceptedResultValue: "",
    resultColorCode: "",
  });
  let apiData;
  const [errors, setErrors] = useState({
    testName: "",
    unit: "",
    incubation: "",
    expirationTime: "",
    positiveValue: "",
    positiveColorCode: "",
    negativeValue: "",
    negativeColorCode: "",
    acceptedResultValue: "",
    resultColorCode: "",
  });

  const [additionalResultFields, setAdditionalResultFields] = useState([
    {
      index: 0,
      Resultvalue: "",
      colorCode: "",
    },
  ]);
  const handleChange = (event) => {
    const { index, name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleChange1 = (event, index, color) => {
    const { value } = event.target;
    const updatedResultFields = [...additionalResultFields];
    color == "result"
      ? (updatedResultFields[index] = {
          index: index,
          Resultvalue: value,
          colorCode: updatedResultFields[index].colorCode,
        })
      : (updatedResultFields[index] = {
          index: index,
          Resultvalue: updatedResultFields[index].Resultvalue,
          colorCode: value,
        });
    setAdditionalResultFields(updatedResultFields);
  };

  const handleValidation = () => {
    const newErrors = {
      testName: "",
      unit: "",
      incubation: "",
      expirationTime: "",
      positiveValue: "",
      positiveColorCode: "",
      negativeValue: "",
      negativeColorCode: "",
      acceptedResultValue: "",
      resultColorCode: "",
    };

    // Validate Test Name (required)
    if (formData.testName.trim() === "") {
      newErrors.testName = "Test Name is required";
    }

    // Validate Unit (required)
    if (formData.unit.trim() === "") {
      newErrors.unit = "Unit is required";
    }

    // Validate Incubation Time (required)
    if (formData.incubation === "") {
      newErrors.incubation = "Incubation Time is required";
    }
    if (formData.expirationTime === "") {
      newErrors.expirationTime = "Expiration Time is required";
    }
    // Validate Qualitative Fields
    if (value === "QUALITATIVE") {
      if (formData.positiveValue.trim() === "") {
        newErrors.positiveValue = "Positive Value is required";
      }
      if (formData.positiveColorCode.trim() === "") {
        newErrors.positiveColorCode = "Positive Color Code is required";
      }
      if (formData.negativeValue.trim() === "") {
        newErrors.negativeValue = "Negative Value is required";
      }
      if (formData.negativeColorCode.trim() === "") {
        newErrors.negativeColorCode = "Negative Color Code is required";
      }
    }

    // Validate Quantitative Fields
    if (value === "QUANTITATIVE") {
      if (formData.acceptedResultValue.trim() === "") {
        newErrors.acceptedResultValue = "Accepted Result Value is required";
      }
      if (formData.resultColorCode.trim() === "") {
        newErrors.resultColorCode = "Result Color Code is required";
      }
    }

    setErrors(newErrors);
  };
  const handleRemoveResultValue = (index) => {
    const updatedFields = additionalResultFields.filter(
      (value) => value.index !== index
    );
    setAdditionalResultFields(updatedFields);
  };

  const handleAddResultValue = (index) => {
    setAdditionalResultFields([
      ...additionalResultFields,
      { index: index, Resultvalue: "", colorCode: "" },
    ]);
  };
  const getExpectedResultDtos = () => {
    const expectedResultDtos = additionalResultFields.map((value, index) => ({
      resultValue: value.Resultvalue,
      colorCode: value.colorCode,
    }));
    return expectedResultDtos;
  };

  const expectedResultDtos = getExpectedResultDtos();

  if (value === "QUALITATIVE") {
    apiData = {
      adminTestDto: {
        testName: formData.testName,
        incubationTime: formData.incubation,
        data: incubationType, //time type
        expirationData: expirationType, //time type
        expirationTime: formData.expirationTime,
        unit: formData.unit,
        tutorialVideo: link,
        testResultImage: profileImage,
        testResult: "QUALITATIVE",
      },
      expectedResultDtos: [
        {
          resultValue: "Positive",
          colorCode: formData.positiveColorCode,
        },
        {
          resultValue: "Negative",
          colorCode: formData.negativeColorCode,
        },
      ],
    };
  } else {
    apiData = {
      adminTestDto: {
        testName: formData.testName,
        incubationTime: formData.incubation,
        unit: formData.unit,
        data: incubationType, //time type
        expirationData: expirationType, //time type
        expirationTime: formData.expirationTime,
        testResultImage: profileImage,
        tutorialVideo: link,
        testResult: "QUANTITATIVE",
      },
      expectedResultDtos: expectedResultDtos,
    };
  }
  const handleSubmit = async () => {
    handleValidation();
    console.log(
      "kfhajsfhjahfajkg lsklfs dfhsdkjfbsdukfjdsfsdyuksndioy bsdfi",
      profileImage
    );

    if (value === "QUALITATIVE") {
      if (
        formData.testName.trim() !== "" &&
        formData.unit.trim() !== "" &&
        formData.incubation !== "" &&
        formData.positiveColorCode.trim() !== "" &&
        formData.expirationTime !== ""
      ) {
        if (link !== null) {
          setLoader(true);
          try {
            const res = await Axios({
              method: "POST",
              url: ApiConfig.addtest,
              headers: {
                Authorization: `Bearer ${window.localStorage.getItem(
                  "id_token"
                )}`,
              },
              data: apiData,
            });

            if (res.data.status === 200) {
              toast.success(res?.data?.message);
              history.goBack();
            }
          } catch (error) {
            setLoader(false);
          }
        } else {
          toast.error("Please Upload Video and Image.");
        }
      }
    } else {
      if (
        formData.testName.trim() !== "" &&
        formData.unit.trim() !== "" &&
        formData.incubation !== "" &&
        formData.expirationTime !== ""
      ) {
        if (link !== null) {
          setLoader(true);
          try {
            const res = await Axios({
              method: "POST",
              url: ApiConfig.addtest,
              headers: {
                Authorization: `Bearer ${window.localStorage.getItem(
                  "id_token"
                )}`,
              },
              data: apiData,
            });

            if (res.data.status === 200) {
              toast.success(res?.data?.message);
              history.goBack();
            } else if (res.data.status === 420) {
              toast.error(res?.data?.message);
            }
          } catch (error) {
            setLoader(false);
          }
        } else {
          toast.error("Please Upload and Image.");
        }
      }
    }
  };
  //videoBase64 image

  const handleUpload = async () => {
    console.log("I am in ipload function", image);
    if (videoBase64 === null) {
      toast.error("Please upload sample video.");
    }
    if (image === "") {
      toast.error("Please upload sample image.");
    }
    if (videoBase64 !== null && image !== "") {
      await addCategoryName();
      await uploadIMG();
    }
  };
  const addCategoryName = async (value) => {
    let base64 = videoBase64.split(",");
    const dataAfterComma = base64[1];
    setLoader(true);

    try {
      const res = await Axios({
        method: "POST",
        url: ApiConfig.uploadVideo,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          fileType: "VIDEO",
        },
        data: [`${dataAfterComma}`],
      });

      if (res.data.status == 200) {
        toast.success(res.data.message);
        setLink(res?.data?.data[0]);
        setLoader(false);
      }
    } catch (error) {
      console.log("Error during the video upload", error);
      setLoader(false);
    }
  };
  return (
    <>
      <PageTitle title="Add Test" />
      <div className={classes.container}>
        <div className={classes.formContainer}>
          {/* Test Name Section */}
          <div className={classes.formSection}>
            <Typography className={classes.sectionTitle}>Test Information</Typography>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <label className={classes.label}>
                  Test Name <span style={{ color: "red" }}>*</span>
                </label>
                <TextField
                  placeholder="Enter test name"
                  type="text"
                  variant="outlined"
                  fullWidth
                  id="testName"
                  size="small"
                  inputProps={{ maxLength: 256 }}
                  name="testName"
                  value={formData.testName}
                  onChange={handleChange}
                  className={classes.TextBox}
                />
                <FormHelperText error className={classes.date}>
                  {errors.testName}
                </FormHelperText>
              </Grid>
            </Grid>
          </div>

          {/* Upload Section */}
          <div className={classes.uploadSection}>
            <Typography className={classes.uploadTitle}>Upload Test Video and Image</Typography>
            <Grid container spacing={3} className={classes.uploadGrid}>

              <Grid item xs={12} md={6}>
                <Typography className={classes.label} style={{ marginBottom: "8px" }}>
                  Test Video <span style={{ color: "red" }}>*</span>
                </Typography>
                {videoBase64 ? (
                  <div className={classes.videoContainer} style={{ position: "relative" }}>
                    <IconButton
                      className={classes.deleteBTN}
                      onClick={() => {
                        setVideoBase64(null);
                        setLink(null);
                      }}
                    >
                      <Delete />
                    </IconButton>
                    <video controls width="100%" style={{ borderRadius: "8px" }}>
                      <source src={videoBase64} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ) : (
                  <DropzoneArea
                    acceptedFiles={["video/*"]}
                    filesLimit={1}
                    onChange={handleVideoChange}
                    dropzoneText="Drag and drop your video file here or click to select"
                  />
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography className={classes.label} style={{ marginBottom: "8px" }}>
                  Test Image <span style={{ color: "red" }}>*</span>
                </Typography>
                <Box className={image == "" ? classes.colorbox : classes.colorbox1}>
                  <DropzoneArea
                    classes={classes.DropzoneArea}
                    acceptedFiles={["image/*"]}
                    maxFileSize={5000000}
                    filesLimit={1}
                    onDelete={() => {
                      setImage("");
                      setProfileImage("");
                    }}
                    onDrop={handleDrop}
                    dropzoneText="Drag and drop your Image file here or click to select"
                  />
                </Box>
              </Grid>
            </Grid>
            
            <div className={classes.uploadButtonContainer}>
              {loader ? (
                <CircularProgress />
              ) : (
                <>
                  {profileImage === "" || link === null ? (
                    <Button
                      onClick={() => {
                        uploadIMG()
                        handleUpload();
                      }}
                      className={classes.btn}
                      variant="contained"
                    >
                      Upload Files
                    </Button>
                  ) : (
                    <Typography className={classes.uploadedStatus}>
                      ✓ Files Uploaded Successfully
                    </Typography>
                  )}
                </>
              )}
            </div>
          </div>
          {/* Time Configuration Section */}
          <div className={classes.formSection}>
            <Typography className={classes.sectionTitle}>Time Configuration</Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <label className={classes.label}>
                  Incubation Time <span style={{ color: "red" }}>*</span>
                </label>
                <FormControl
                  variant="outlined"
                  fullWidth
                  className={classes.select}
                >
                  <Select
                    value={formData.incubation}
                    onChange={handleChange}
                    displayEmpty
                    inputProps={{
                      name: "incubation",
                      id: "incubation-select",
                    }}
                  >
                    <MenuItem value="">Select Incubation Time</MenuItem>
                    {Array.from({ length: 60 }, (_, index) => (
                      <MenuItem key={index + 1} value={index + 1}>
                        {index + 1}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormHelperText error className={classes.date}>
                  {errors.incubation}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} md={6}>
                <label className={classes.label}>
                  Incubation Time Type <span style={{ color: "red" }}>*</span>
                </label>
                <FormControl
                  variant="outlined"
                  fullWidth
                  className={classes.select}
                >
                  <Select
                    margin="dense"
                    name="incubation"
                    value={incubationType}
                    onChange={(e) => setIncubationType(e.target.value)}
                    defaultValue="Select Incubation Time"
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                  >
                    <MenuItem value="SEC">Seconds</MenuItem>
                    <MenuItem value="MIN">Minutes</MenuItem>
                    <MenuItem value="HRS">Hours</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <label className={classes.label}>
                  Expiration Time <span style={{ color: "red" }}>*</span>
                </label>
                <FormControl
                  variant="outlined"
                  fullWidth
                  className={classes.select}
                >
                  <Select
                    value={formData.expirationTime}
                    onChange={handleChange}
                    displayEmpty
                    inputProps={{
                      name: "expirationTime",
                      id: "expirationTime-select",
                    }}
                  >
                    <MenuItem value="">Select Expiration Time</MenuItem>
                    {Array.from({ length: 60 }, (_, index) => (
                      <MenuItem key={index + 1} value={index + 1}>
                        {index + 1}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormHelperText error className={classes.date}>
                  {errors.expirationTime}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} md={6}>
                <label className={classes.label}>
                  Expiration Time Type <span style={{ color: "red" }}>*</span>
                </label>
                <FormControl
                  variant="outlined"
                  fullWidth
                  className={classes.select}
                >
                  <Select
                    margin="dense"
                    name="incubation"
                    value={expirationType}
                    onChange={(e) => setExpirationType(e.target.value)}
                    defaultValue="Select Incubation Time"
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                  >
                    <MenuItem value="SEC">Seconds</MenuItem>
                    <MenuItem value="MIN">Minutes</MenuItem>
                    <MenuItem value="HRS">Hours</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </div>

          {/* Unit Section */}
          <div className={classes.formSection}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <label className={classes.label}>
                  Unit <span style={{ color: "red" }}>*</span>
                </label>
                <TextField
                  placeholder="Enter unit"
                  type="text"
                  variant="outlined"
                  fullWidth
                  id="unit"
                  size="small"
                  name="unit"
                  value={formData.unit}
                  onChange={handleChange}
                  className={classes.TextBox}
                />
                <FormHelperText error className={classes.date}>
                  {errors.unit}
                </FormHelperText>
              </Grid>
            </Grid>
          </div>

          {/* Expected Test Result Section */}
          <div className={classes.resultSection}>
            <Typography className={classes.sectionTitle}>Expected Test Result Details</Typography>
            <RadioGroup
              name="testResultType"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              className={classes.radioGroup}
            >
              <FormControlLabel
                value="QUALITATIVE"
                control={<Radio color="primary" />}
                label={<span className={classes.radioLabel}>Qualitative Result</span>}
              />
              <FormControlLabel
                value="QUANTITATIVE"
                control={<Radio color="primary" />}
                label={<span className={classes.radioLabel}>Quantitative Result</span>}
              />

              {value === "QUALITATIVE" ? (
                <Grid container spacing={3} style={{ marginTop: "16px" }}>
                  <Grid item xs={12} md={6}>
                    <label className={classes.label}>Value</label>
                    <Typography className={classes.resultValueDisplay}>
                      Positive
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <label className={classes.label}>
                      Color Code <span style={{ color: "red" }}>*</span>
                    </label>
                    <TextField
                      placeholder="Enter color code (e.g., #FF0000)"
                      type="text"
                      variant="outlined"
                      fullWidth
                      id="positiveColorCode"
                      size="small"
                      inputProps={{ maxLength: 7 }}
                      name="positiveColorCode"
                      value={formData.positiveColorCode}
                      onChange={handleChange}
                      className={classes.TextBox}
                    />
                    <FormHelperText error className={classes.date}>
                      {errors.positiveColorCode}
                    </FormHelperText>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <label className={classes.label}>Value</label>
                    <Typography className={classes.resultValueDisplay}>
                      Negative
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <label className={classes.label}>
                      Color Code <span style={{ color: "red" }}>*</span>
                    </label>
                    <TextField
                      placeholder="Enter color code (e.g., #00FF00)"
                      type="text"
                      variant="outlined"
                      fullWidth
                      id="negativeColorCode"
                      size="small"
                      inputProps={{ maxLength: 7 }}
                      name="negativeColorCode"
                      value={formData.negativeColorCode}
                      onChange={handleChange}
                      className={classes.TextBox}
                    />
                    <FormHelperText error className={classes.date}>
                      {errors.negativeColorCode}
                    </FormHelperText>
                  </Grid>
                </Grid>
              ) : (
                <div style={{ marginTop: "16px" }}>
                  <div style={{ marginBottom: "16px" }}>
                    <Button
                      onClick={() => {
                        handleAddResultValue(additionalResultFields.length);
                      }}
                      variant="contained"
                      className={classes.btn1}
                    >
                      + Add Result Value
                    </Button>
                  </div>
                  
                  {additionalResultFields.map((values, index) => (
                    <Grid container spacing={3} key={`result-field-${index}`} style={{ marginBottom: "16px" }}>
                      <Grid item xs={12} md={5}>
                        <label className={classes.label}>
                          Accepted Test Result Value
                        </label>
                        <TextField
                          placeholder="Enter result value"
                          type="text"
                          variant="outlined"
                          fullWidth
                          id={`acceptedResultValue-${index}`}
                          size="small"
                          inputProps={{ maxLength: 255 }}
                          name={`acceptedResultValue-${index}`}
                          value={values.Resultvalue}
                          onChange={(event) =>
                            handleChange1(event, index, "result")
                          }
                          className={classes.TextBox}
                        />
                        <div className="error" style={{ color: "red" }}>
                          {errors[`acceptedResultValue-${index}`]}
                        </div>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <label className={classes.label}>
                          Color Code <span style={{ color: "red" }}>*</span>
                        </label>
                        <TextField
                          placeholder="Enter color code (e.g., #FF0000)"
                          type="text"
                          variant="outlined"
                          fullWidth
                          id={`resultColorCode-${index}`}
                          size="small"
                          inputProps={{ maxLength: 7 }}
                          name={`resultColorCode-${index}`}
                          value={values.colorCode}
                          onChange={(event) =>
                            handleChange1(event, index, "color")
                          }
                          className={classes.TextBox}
                        />
                        <div className="error" style={{ color: "red" }}>
                          {errors[`resultColorCode-${index}`]}
                        </div>
                      </Grid>

                      <Grid item xs={12} md={3} style={{ display: "flex", alignItems: "flex-end" }}>
                        <Button
                          onClick={() => handleRemoveResultValue(values.index)}
                          className={classes.btn}
                          variant="outlined"
                          style={{ 
                            background: "#e74c3c", 
                            color: "white",
                            border: "none",
                            "&:hover": {
                              background: "#c0392b"
                            }
                          }}
                        >
                          Remove
                        </Button>
                      </Grid>
                    </Grid>
                  ))}
                </div>
              )}
            </RadioGroup>
          </div>

          {/* Action Buttons */}
          <div className={classes.buttonContainer}>
            <Button
              className={classes.btn}
              variant="outlined"
              onClick={() => history.goBack()}
              style={{
                background: "transparent",
                color: "#6c757d",
                border: "2px solid #6c757d",
                "&:hover": {
                  background: "#6c757d",
                  color: "white",
                }
              }}
            >
              Cancel
            </Button>
            <Button
              className={classes.btn}
              variant="contained"
              onClick={handleSubmit}
            >
              Add Test
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Addtest;
